module.exports = __webpack_public_path__ + "static/media/smartmirror.d88540e3.png";